import { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { Button } from './ui/button';

const SystemMessageModal = ({ messages, onAcknowledge }) => {
  const [acknowledgedIds, setAcknowledgedIds] = useState(() => {
    try {
      const stored = sessionStorage.getItem('acknowledgedCriticalMessages');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  // Filter for critical messages that haven't been acknowledged
  const criticalMessages = messages?.filter(msg => 
    msg.type === 'critical' && !acknowledgedIds.includes(msg.id)
  ) || [];

  const handleAcknowledge = (msgId) => {
    const newAcknowledged = [...acknowledgedIds, msgId];
    setAcknowledgedIds(newAcknowledged);
    sessionStorage.setItem('acknowledgedCriticalMessages', JSON.stringify(newAcknowledged));
    if (onAcknowledge) onAcknowledge(msgId);
  };

  if (criticalMessages.length === 0) return null;

  const currentMessage = criticalMessages[0];

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[100]" data-testid="critical-message-modal">
      <div className="bg-[#0a0a0a] border-2 border-red-500 rounded-lg max-w-lg w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-red-900/50 px-6 py-4 flex items-center gap-3">
          <AlertCircle className="h-8 w-8 text-red-400 animate-pulse" />
          <div>
            <p className="text-red-400 text-sm font-medium uppercase tracking-wider">Critical System Alert</p>
            <h3 className="text-white text-xl font-bold">{currentMessage.title}</h3>
          </div>
        </div>
        
        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-gray-300 text-base leading-relaxed whitespace-pre-wrap">
            {currentMessage.message}
          </p>
          
          {currentMessage.end_time && (
            <p className="text-red-400 text-sm mt-4">
              Scheduled until: {new Date(currentMessage.end_time).toLocaleString()}
            </p>
          )}
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 bg-[#111] border-t border-red-900/50 flex justify-end">
          <Button
            onClick={() => handleAcknowledge(currentMessage.id)}
            className="bg-red-600 hover:bg-red-700 text-white px-6"
            data-testid="acknowledge-critical-btn"
          >
            I UNDERSTAND
          </Button>
        </div>
        
        {/* Multiple messages indicator */}
        {criticalMessages.length > 1 && (
          <div className="px-6 py-2 bg-red-900/30 text-red-300 text-sm text-center">
            {criticalMessages.length - 1} more critical message{criticalMessages.length > 2 ? 's' : ''} to view
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemMessageModal;
